import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICategoryPartResponse, IVehicleCategoryPartsFilters } from "../models/Part";

export default function useVehicleMatchingParts(
  vehicleId: string | undefined,
  filters: IVehicleCategoryPartsFilters,
  enabled: boolean
) {
  const { post } = useApiHelper();
  const staleTime = 1000 * 60 * 10; // 10 minutes

  const parts = useQuery({
    queryKey: ["vehicleMatchingParts", vehicleId, filters],
    queryFn: () =>
      post<IVehicleCategoryPartsFilters, ICategoryPartResponse>(
        `/part/vehicle/${vehicleId}/parts/search`,
        filters
      ),
    enabled: enabled && !!vehicleId,
    staleTime: staleTime,
  });

  return {
    parts,
  };
}
